<template>
  <div class="table">
      <div class="row header">
          <div class="cell">
              Order ID
          </div>
          <div class="cell">
              Date
          </div>
          <div class="cell">
              Status
          </div>
      </div>
      
      <div v-for="order in data" :key="order.id" class="row">
          <div class="cell" data-title="Order ID">Order {{ order.id }}</div>
          <div class="cell" data-title="Date">{{ formatDate(order.created_at) }}</div>
          <div class="cell" data-title="Status">{{ order.status_name }}</div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
  export default {
    data() {
      return {
        data: [],
      }
    },
    methods: {
      async getMyOrders() {
        try {
          let fData = new FormData();
          const response = await axios.get('/user/get/orders', fData);
          this.data = response.data.data;
        } catch (error) {
          console.error('Error updating wishlist:', error);
        }
      },
      formatDate(dateString) {
      const options = { day: 'numeric', month: 'long', year: 'numeric' };
          const date = new Date(dateString);
          const formattedDate = date.toLocaleDateString('en-GB', options);
          const [day, month, year] = formattedDate.split(' ');
          return `${day} ${month.charAt(0).toUpperCase() + month.slice(1)}. ${year}`;
      }
    },
    mounted () {
      this.getMyOrders();
    },
  }
</script>

<style scoped>
.table {
width: 100%;
display: flex;
flex-direction: column;
gap: 16px;
max-width: 640px;
}

.row.header {
  background: unset;
  border-bottom: 1px solid rgb(222, 230, 234);
}

.row {
display: flex;
background: rgb(222, 230, 234);
gap: 16px;
}

.cell {
  padding: 16px 24px;
  flex: 1;
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  white-space: nowrap;
}

@media screen and (max-width: 580px) {
.table {
  display: block;
}

.row {
  padding: 14px 0 7px;
  display: block;
}

.row.header {
  padding: 0;
  height: 6px;
}

.row.header .cell {
  display: none;
}

.row .cell {
  margin-bottom: 10px;
}

.row .cell:before {
  margin-bottom: 3px;
  content: attr(data-title);
  min-width: 98px;
  font-size: 10px;
  line-height: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: #969696;
  display: block;
}
}

@media screen and (max-width: 580px) {
.cell {
  padding: 2px 16px;
  display: block;
}
}
</style>